document.addEventListener('DOMContentLoaded', function () {
  var parents = document.querySelectorAll('.mega-parent');
  parents.forEach(function (parent) {
    parent.addEventListener('mouseenter', function () {
      if (window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) {
        parent.setAttribute('open', '');
      }
    });
    parent.addEventListener('mouseleave', function () {
      if (window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) {
        parent.removeAttribute('open');
      }
    });
  });
});
